import { Label } from './ui/label';
import { Input } from './ui/input';

export function DateRangeFilter({ dateFrom, dateTo, setDateFrom, setDateTo, prefix = 'date' }) {
  return (
    <>
      <div className="form-field">
        <Label className="text-xs text-slate-500">From</Label>
        <Input type="date" value={dateFrom} onChange={e => setDateFrom(e.target.value)} className="w-40 bg-white" data-testid={`${prefix}-date-from`} />
      </div>
      <div className="form-field">
        <Label className="text-xs text-slate-500">To</Label>
        <Input type="date" value={dateTo} onChange={e => setDateTo(e.target.value)} className="w-40 bg-white" data-testid={`${prefix}-date-to`} />
      </div>
    </>
  );
}
